export function setCookie(name, value) {
    const date = new Date(new Date().getTime() + 3600000 * 24 * 365);

    const domain = document.location.hostname;

    if (environment_type === 'production') {
        document.cookie = name + "=" + value + "; path=/; domain=" + domain + "; expires=" + date.toUTCString() + "; secure; SameSite=Strict";
    } else {
        document.cookie = name + "=" + value + "; path=/; domain=" + domain + "; expires=" + date.toUTCString();
    }
}

export function getCookie(name) {
    const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}

export function delCookie(name) {
    const domain = document.location.hostname;
    const expires = 'Thu, 01 Jan 1970 00:00:00 UTC';

    document.cookie = `${name}=; path=/; domain=${domain}; expires=${expires}; secure; SameSite=Strict`;
}

export async function getData(url, options = {}) {
    const res = await fetch(url, options)
    return await res.json()
}
